import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { Skeleton } from "~/components/ui/skeleton";
import { useEmployeePermissions } from "~/hooks/use-employee-permissions";
import { toConvexTableId } from "~/lib/convex-table-id";

import { OnlineOrderingSettingsForm } from "../../../../components/online-ordering/online-ordering-settings-form";

export const Route = createFileRoute(
  "/_authenticated/locations/$id/online-ordering"
)({
  component: OnlineOrderingSettingsPage,
});

function OnlineOrderingSettingsPage() {
  const { id } = Route.useParams();
  const { hasPermission, isLoading, hasEmployee } = useEmployeePermissions();
  const canViewIntegrations = hasPermission("viewIntegrations");

  if (isLoading) {
    return <Skeleton className="h-96 w-full" />;
  }

  if (!hasEmployee) {
    return (
      <Alert>
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>No Employee Profile</AlertTitle>
        <AlertDescription>
          Your account is not linked to an employee profile. Contact your
          organization admin to set up your employee record with the appropriate
          permissions.
        </AlertDescription>
      </Alert>
    );
  }

  if (!canViewIntegrations) {
    return (
      <Alert variant="destructive">
        <ShieldAlert className="h-4 w-4" />
        <AlertTitle>Access Denied</AlertTitle>
        <AlertDescription>
          You don&apos;t have permission to view online ordering settings.
          Contact your manager to request access.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <OnlineOrderingSettingsForm locationId={toConvexTableId("locations", id)} />
  );
}
